import { observer } from "mobx-react-lite";
import styled, { useTheme } from "~/ui/styled"
import { Button, Flex, Text } from '~components/El'

const cells = {
  1: '100%',
  2: '48%',
  3: '31%',
  4: '23%',
  5: '18%',
  6: '15%'
}

const QuickRow = styled(Flex)`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 8px 0;
`
const QuickButtons: React.FC<{
    value: string;
    options: string[];
    span?: number;
    unit?: string;
    onChange: (v: string) => void;
}> = ({
    onChange,
    options = [],
    span = 4,
    value = "",
    unit = "¥"
}) => {
    const theme = useTheme();
    return (
        <QuickRow>
            {options.map((v, i) => (
                <Button
                    key={i}
                    width={cells[span]}
                    height="30px"
                    borderRadius="8px"
                    mb="10px"
                    border={v === value ? "1px solid #fa5251" : "none"}
                    bg={v === value ? "rgba(250, 82, 81, 0.1)" : theme.colors.background}
                    onClick={() => onChange(v)}
                >
                    <Text color={v === value ? theme.colors.error : theme.colors.secondary}>{unit}{v}</Text>
                </Button>
            ))}
        </QuickRow>
    );
};

export default observer(QuickButtons);